import React, { useState, useEffect, useRef } from "react";
import FilterButton from "../../../../src/ui/buttons/FilterButton";
import CaseListingFilter from "./CaseListingFilter";

function CaseListingHeader({ setSearchParameter, setHitReload }) {
    const [SortAsc, setSortAsc] = useState(true);

    // FIX: Add ref to track initial mount and prevent early setSearchParameter call
    const isInitialMount = useRef(true); 

    // filter
    const [showFilter, setShowFilter] = useState(false);
    
    // Updated filterData structure
    const [filterData, setFilterData] = useState({
        // Existing header fields
        search: "",
        batch_no: "",
        date_from: null,
        date_to: null,
        specific_date: null,
        batch_status: "",
        all_communication_mode: "",
        
        // --- ADVANCED FILTER FIELDS ---
        borrower_name: "",
        client: "",
        branch: "", // <-- This is the Branch ID
        relief_sought: "", 
        // New state for Document Type
        document_type: "", 
        case_status: "", 
        email_reply_status: "",
        case_data_status: "",
    });
    const [searchBy, setSearchBy] = useState("");

    const filterMapping = () => {
        const params = {};

        // Existing Filter Mappings (kept for context)
        if (filterData?.search) {
             params.batch_name = filterData.search;
        }
        if (filterData?.batch_no) {
             params.client_batch_id = filterData.batch_no;
        }
        if (filterData?.batch_status) {
             params.batch_status = filterData.batch_status;
        }
       
        // Advanced Filter Mappings
        if (filterData?.borrower_name) {
             params.customer_name = filterData.borrower_name;
        }
        if (filterData?.client) {
             params.client = filterData.client;
        }
        
        // ** MODIFIED BRANCH MAPPING LOGIC (Sends Branch ID) **
        if (filterData?.branch && filterData.branch !== "") {
            params.branch = filterData.branch; 
        }
        
        // Mapped: 'Type of Case' to API's 'relief_sought'
        if (filterData?.relief_sought) {
             params.relief_sought = filterData.relief_sought;
        }
        
        //  Document Type Mapping
        if (filterData?.document_type) {
            // Assuming the API key is also 'document_type'
             params.document_type = filterData.document_type;
        }

        // ** MODIFICATION START **
        // Mapped: 'Filing Status' to send 'Filed' or 'Not Filed' strings
        if (filterData?.case_status === 'Filed') {
             params.case_status = 'filed';
        } else if (filterData?.case_status === 'Not Filed') {
             params.case_status = 'not_filed';
        }

        // Special boolean conversion for 'email_replied' - THIS LOGIC IS CORRECT
        if (filterData?.email_reply_status === 'replied') {
             params.email_replied = true;
        } else if (filterData?.email_reply_status === 'not_replied') {
             params.email_replied = false;
        }

        // Mapped: 'Case Data' status to 'missing_data_pendency' boolean - THIS LOGIC IS CORRECT
        // This only runs if filterData.case_data_status is 'True' or 'False'
        if (filterData?.case_data_status === 'True') {
            params.missing_data_pendency = true;
        } else if (filterData?.case_data_status === 'False') {
            params.missing_data_pendency = false;
        }
        
        return params;
    };

    useEffect(() => {
        // FIX IMPLEMENTATION: Skip the execution on the initial mount
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }
        
        // This runs only when filterData changes AFTER the initial mount.
        setSearchParameter({ ...filterMapping() });
    }, [filterData, setSearchParameter]); 

    // ... (handleDownloadBulkFile and handleActionSelect functions remain the same) ...

    const handleDownloadBulkFile = () => {
        // Download functionality - to be implemented
        console.log("Download Bulk Batch File clicked");
        // You can add your download logic here
    };

    const handleActionSelect = (action) => {
        console.log("Action selected:", action);
        // Handle different actions based on selection
        switch (action) {
            case 'assign-advocate':
                console.log("Assign to Advocate selected");
                // Add your logic here
                break;
            case 'document-pending':
                console.log("Document Pending selected");
                // Add your logic here
                break;
            case 'update-case-status':
                console.log("Update Case Status selected");
                // Add your logic here
                break;
            case 'bulk-communicate':
                console.log("Bulk Communicate selected");
                // Add your logic here
                break;
            default:
                break;
        }
    };

    return (
        <div className="row d-flex d-wrap justify-between filter-section">
            <div className="d-flex d-wrap align-items-center justify-content-between gap-4">
                <div className="d-flex align-center">
                    <FilterButton 
                        onClick={() => setShowFilter(true)} 
                        // Check if any filter value is truthy (excluding null or empty string)
                        active={!!filterData && !!Object.values(filterData)?.some((el) => !!el && el !== null && el !== "")} 
                    />
                </div>

                <div className="d-wrap d-flex align-items-center justify-content-end gap-2">
                    {/* Select Option for Action Dropdown */}
                    <div className="dropdown ms-2">
                        <button 
                            className="btn btn-primary btn-lg dropdown-toggle" 
                            type="button" 
                            id="actionDropdown" 
                            data-bs-toggle="dropdown" 
                            aria-expanded="false"
                        >
                            Select Option for Action
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="actionDropdown">
                            <li>
                                <a 
                                    className="dropdown-item" 
                                    href="#" 
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleActionSelect('assign-advocate');
                                    }}
                                >
                                    Assign to Advocate
                                </a>
                            </li>
                            <li>
                                <a 
                                    className="dropdown-item" 
                                    href="#" 
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleActionSelect('document-pending');
                                    }}
                                >
                                    Document Pending
                                </a>
                            </li>
                            <li>
                                <a 
                                    className="dropdown-item" 
                                    href="#" 
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleActionSelect('update-case-status');
                                    }}
                                >
                                    Update Case Status
                                </a>
                            </li>
                            <li>
                                <a 
                                    className="dropdown-item" 
                                    href="#" 
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleActionSelect('bulk-communicate');
                                    }}
                                >
                                    Bulk Communicate
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Filter Modal */}
            <CaseListingFilter
                show={showFilter}
                close={() => setShowFilter(false)}
                prevFilter={filterData}
                setPrevFilter={setFilterData}
                searchByPrev={searchBy}
                setSearchByPrev={setSearchBy}
            />

        </div>
    );
}

export default CaseListingHeader;